import { useMutation, useQueryClient } from '@tanstack/react-query';
import { onboardingKeys } from './onboardingKeys';
import { completeOnboarding } from '../api/onboardingApi';
import type { OnboardingStatusResponse } from '../api/onboardingApi';

export function useCompleteOnboarding() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: completeOnboarding,
    onSuccess: data => {
      queryClient.setQueryData<OnboardingStatusResponse>(
        onboardingKeys.status(),
        current =>
          current
            ? { ...current, gettingStartedCompletedAt: data.completedAt }
            : current
      );
    },
  });
}
